import React, { useState } from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";

import "./ManagedITServices.css";
import managedITImg from "./managedit.png";

import {
  FaServer,
  FaTools,
  FaBug,
  FaDatabase,
  FaGlobe,
  FaRocket,
  FaShieldAlt,
  FaSyncAlt,
  FaClock,
  FaHandshake,
  FaUserTie,
  FaDollarSign,
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
  FaCloud,
  FaReact,
  FaNodeJs,
  FaJava,
  FaWindows,
  FaLinux,
  FaAws,
  FaHeadset,
  FaChartLine,
  FaClipboardCheck,
  FaBusinessTime
} from "react-icons/fa";

import {
  SiMongodb,
  SiMysql,
  SiPostgresql,
  SiDocker
} from "react-icons/si";

export default function ManagedITServices() {

  const navigate = useNavigate();

  const [openFAQ, setOpenFAQ] = useState(null);

  const handleContact = () => {
    navigate("/", {
      state: {
        scrollTo: "contact",
      },
    });
  };

  const faqs = [
    {
      question: "What are Managed IT Services?",
      answer:
        "Managed IT Services provide continuous monitoring, maintenance, and support for business infrastructure, applications, servers, databases, and networks."
    },
    {
      question: "Do you provide 24×7 production support?",
      answer:
        "Yes. We provide round-the-clock monitoring and rapid incident response for mission-critical business systems."
    },
    {
      question: "Can you manage cloud infrastructure?",
      answer:
        "Yes. Our engineers manage AWS, Azure, cloud servers, databases, and enterprise infrastructure."
    },
    {
      question: "Do you offer disaster recovery services?",
      answer:
        "Absolutely. We provide backup strategies, disaster recovery planning, business continuity, and restoration services."
    },
    {
      question: "Which engagement model should I choose?",
      answer:
        "Time & Material works best for changing requirements, while Fixed Price is ideal for projects with clearly defined scope."
    },
    {
      question: "How do I get started?",
      answer:
        "Simply contact our team through the Contact section and we'll schedule a consultation."
    }
  ];

  return ( 
    <>
      <Navbar />
      {/* ================= HERO ================= */}

      <section className="managed-hero">

        <div className="managed-hero-content">

          <span className="hero-tag">
            MANAGED IT SERVICES
          </span>

          <h1>
            Reliable IT Operations.
            <br />
            <span>Proactive Support.</span>
            <br />
            Predictable Costs.
          </h1>

          <p>
            Technology powers every modern business. E-Forum Systems provides
            end-to-end Managed IT Services that keep your applications,
            infrastructure, servers, databases and business systems secure,
            optimized and available 24×7.
          </p>

          <div className="hero-features">

            <div className="feature-pill">
              <FaServer />
              <span>24×7 Monitoring</span>
            </div>

            <div className="feature-pill">
              <FaShieldAlt />
              <span>Secure Infrastructure</span>
            </div>

            <div className="feature-pill">
              <FaCloud />
              <span>Cloud Support</span>
            </div>

            <div className="feature-pill">
              <FaHeadset />
              <span>Dedicated Experts</span>
            </div>

          </div>

          <div className="hero-buttons">

            <Link
              to="managed-services"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="btn-primary">
                Explore Services
              </button>
            </Link>

            <button
              className="btn-secondary"
              onClick={handleContact}
            >
              Request Consultation
            </button>

          </div>

        </div>

        <div className="managed-hero-image">

          <img
            src={managedITImg}
            alt="Managed IT Services"
          />

        </div>

      </section>

      {/* ================= STATISTICS ================= */}

      <section className="managed-stats">

        <div className="stats-card">

          <FaServer className="stats-icon" />

          <h3>24×7</h3>

          <p>Production Support</p>

        </div>

        <div className="stats-card">

          <FaShieldAlt className="stats-icon" />

          <h3>99.9%</h3>

          <p>System Availability</p>

        </div>

        <div className="stats-card">

          <FaCloud className="stats-icon" />

          <h3>Cloud</h3>

          <p>Infrastructure Support</p>

        </div>

        <div className="stats-card">

          <FaHeadset className="stats-icon" />

          <h3>Fast</h3>

          <p>Issue Resolution</p>

        </div>

      </section>

      {/* ================= OUR SERVICES ================= */}
      <section id="managed-services">
        <div className="section-heading">
          <span>OUR SERVICES</span>

          <h2>Comprehensive Managed IT Solutions</h2>

          <p>
            From infrastructure management to disaster recovery,
            we provide complete managed IT services that keep your
            business secure, available and performing at its best.
          </p>

        </div>

        <div className="services-grid">

<div className="service-card">

    <div className="service-header">

        <div className="service-icon">
            <FaHeadset />
        </div>

        <h3>24×7 Production Support</h3>

    </div>

    <p>
        Round-the-clock monitoring and incident management to ensure uninterrupted business operations.
    </p>

    <ul>
        <li><FaCheckCircle /> Incident Management</li>
        <li><FaCheckCircle /> System Monitoring</li>
        <li><FaCheckCircle /> Root Cause Analysis</li>
        <li><FaCheckCircle /> Service Restoration</li>
    </ul>

</div>

          <div className="service-card">

            <div className="service-icon">
              <FaBug />
            </div>

            <h3>Bug Fixes & Support</h3>

            <p>
              Rapid issue resolution and application maintenance
              for enterprise software and business applications.
            </p>

            <ul>
              <li><FaCheckCircle /> Web Applications</li>
              <li><FaCheckCircle /> Enterprise Systems</li>
              <li><FaCheckCircle /> APIs</li>
              <li><FaCheckCircle /> Backend Services</li>
            </ul>

          </div>

          <div className="service-card">

            <div className="service-icon">
              <FaDatabase />
            </div>

            <h3>Backup & Recovery</h3>

            <p>
              Automated backups and disaster recovery strategies
              that protect mission-critical business data.
            </p>

            <ul>
              <li><FaCheckCircle /> Database Backup</li>
              <li><FaCheckCircle /> Website Backup</li>
              <li><FaCheckCircle /> Recovery Planning</li>
              <li><FaCheckCircle /> Restore Validation</li>
            </ul>

          </div>

          <div className="service-card">

            <div className="service-icon">
              <FaTools />
            </div>

            <h3>Application Maintenance</h3>

            <p>
              Continuous maintenance to improve security,
              reliability and long-term application health.
            </p>

            <ul>
              <li><FaCheckCircle /> Security Updates</li>
              <li><FaCheckCircle /> Framework Upgrades</li>
              <li><FaCheckCircle /> Version Management</li>
              <li><FaCheckCircle /> Feature Enhancements</li>
            </ul>

          </div>

          <div className="service-card">

            <div className="service-icon">
              <FaChartLine />
            </div>

            <h3>Performance Optimization</h3>

            <p>
              Improve application speed, database efficiency
              and infrastructure performance.
            </p>

            <ul>
              <li><FaCheckCircle /> Query Optimization</li>
              <li><FaCheckCircle /> Database Tuning</li>
              <li><FaCheckCircle /> Resource Management</li>
              <li><FaCheckCircle /> Application Scaling</li>
            </ul>

          </div>

          <div className="service-card">

            <div className="service-icon">
              <FaServer />
            </div>

            <h3>Infrastructure Support</h3>

            <p>
              Server administration, cloud deployment and
              enterprise infrastructure management.
            </p>

            <ul>
              <li><FaCheckCircle /> Windows & Linux</li>
              <li><FaCheckCircle /> Cloud Platforms</li>
              <li><FaCheckCircle /> Database Servers</li>
              <li><FaCheckCircle /> Security Hardening</li>
            </ul>

          </div>

        </div>

      </section>
          {/* ================= ENGAGEMENT MODELS ================= */}

      <section className="engagement-models">

        <div className="section-heading">

          <span>ENGAGEMENT MODELS</span>

          <h2>Flexible Engagement Models</h2>

          <p>
            Choose a support model that aligns with your operational
            requirements, project scope and business budget.
          </p>

        </div>

        <div className="models-grid">

          {/* Time & Material */}

          <div className="model-card">

            <div className="model-icon">
              <FaClock />
            </div>

            <h3>Time & Material</h3>

            <p>
              Ideal for organizations with changing priorities,
              evolving requirements and ongoing enhancements.
            </p>

            <ul>

              <li><FaCheckCircle /> Flexible resource allocation</li>

              <li><FaCheckCircle /> Pay only for actual effort</li>

              <li><FaCheckCircle /> Faster onboarding</li>

              <li><FaCheckCircle /> Continuous improvements</li>

              <li><FaCheckCircle /> Scalable support</li>

            </ul>

            <button
              className="model-btn"
              onClick={handleContact}
            >
              Request Consultation
            </button>

          </div>

          {/* Fixed Price */}

          <div className="model-card featured-model">

            <div className="featured-badge">
              MOST POPULAR
            </div>

            <div className="model-icon">
              <FaClipboardCheck />
            </div>

            <h3>Fixed Price</h3>

            <p>
              Best for organizations with clearly defined scope,
              milestones and predictable support requirements.
            </p>

            <ul>

              <li><FaCheckCircle /> Fixed support hours</li>

              <li><FaCheckCircle /> Clearly defined deliverables</li>

              <li><FaCheckCircle /> Milestone-based execution</li>

              <li><FaCheckCircle /> Transparent pricing</li>

              <li><FaCheckCircle /> Predictable budgeting</li>

            </ul>

            <button
              className="model-btn"
              onClick={handleContact}
            >
              Get Started
            </button>

          </div>

        </div>

      </section>
        {/* ================= SUPPORT COVERAGE ================= */}

<section className="support-coverage">

  <div className="section-heading">

    <span>SUPPORT COVERAGE</span>

    <h2>Choose Your Support Plan</h2>

    <p>
      Select the service coverage that best matches your operational
      requirements and business-critical workloads.
    </p>

  </div>

  <div className="coverage-grid">

    {/* 24×7 */}

    <div className="coverage-card featured-coverage">

      <div className="coverage-icon">
        <FaHeadset />
      </div>

      <h3>24×7 Support</h3>

      <h4>Mission Critical Systems</h4>

      <p>
        Continuous monitoring and immediate response for applications
        that require maximum uptime.
      </p>

      <ul>
        <li><FaCheckCircle /> Round-the-clock Monitoring</li>
        <li><FaCheckCircle /> Immediate Incident Response</li>
        <li><FaCheckCircle /> Priority Escalation</li>
        <li><FaCheckCircle /> Business Continuity</li>
      </ul>

    </div>

    {/* 24×5 */}

    <div className="coverage-card">

      <div className="coverage-icon">
        <FaClock />
      </div>

      <h3>24×5 Support</h3>

      <h4>Global Business Operations</h4>

      <p>
        Weekday support for businesses operating across multiple
        shifts and international time zones.
      </p>

      <ul>
        <li><FaCheckCircle /> Extended Weekday Support</li>
        <li><FaCheckCircle /> Multi-shift Coverage</li>
        <li><FaCheckCircle /> Remote Assistance</li>
        <li><FaCheckCircle /> Preventive Monitoring</li>
      </ul>

    </div>

    {/* 8×5 */}

    <div className="coverage-card">

      <div className="coverage-icon">
        <FaBusinessTime />
      </div>

      <h3>8×5 Support</h3>

      <h4>Business Hours</h4>

      <p>
        Cost-effective support for organizations operating during
        standard business hours.
      </p>

      <ul>
        <li><FaCheckCircle /> Office Hours Support</li>
        <li><FaCheckCircle /> Scheduled Maintenance</li>
        <li><FaCheckCircle /> Technical Assistance</li>
        <li><FaCheckCircle /> Routine Monitoring</li>
      </ul>

    </div>

  </div>

</section>
{/* ================= WHY CHOOSE US ================= */}

<section className="why-managed">

  <div className="section-heading">

    <span>WHY E-FORUM SYSTEMS</span>

    <h2>Why Businesses Choose Our Managed IT Services</h2>

    <p>
      We combine technical expertise, proactive monitoring, and flexible
      engagement models to help organizations reduce downtime, improve
      performance, and keep business-critical systems running smoothly.
    </p>

  </div>

  <div className="why-grid">

    <div className="why-card">
      <FaUserTie className="why-icon" />
      <h3>Experienced Professionals</h3>
      <p>
        Skilled engineers with extensive experience in enterprise
        infrastructure, applications and cloud environments.
      </p>
    </div>

    <div className="why-card">
      <FaServer className="why-icon" />
      <h3>24×7 Monitoring</h3>
      <p>
        Continuous monitoring helps detect and resolve issues before
        they impact your business operations.
      </p>
    </div>

    <div className="why-card">
      <FaTools className="why-icon" />
      <h3>Proactive Maintenance</h3>
      <p>
        Regular updates, patches and preventive maintenance improve
        system reliability and reduce downtime.
      </p>
    </div>

    <div className="why-card">
      <FaShieldAlt className="why-icon" />
      <h3>Business Continuity</h3>
      <p>
        Backup strategies and disaster recovery planning ensure your
        critical business data remains protected.
      </p>
    </div>

    <div className="why-card">
      <FaDollarSign className="why-icon" />
      <h3>Predictable Costs</h3>
      <p>
        Flexible engagement models provide transparent pricing and
        controlled IT operational expenses.
      </p>
    </div>

    <div className="why-card">
      <FaRocket className="why-icon" />
      <h3>Faster Resolution</h3>
      <p>
        Rapid issue identification and quick service restoration
        minimize downtime and improve productivity.
      </p>
    </div>

    <div className="why-card">
      <FaCloud className="why-icon" />
      <h3>Cloud Expertise</h3>
      <p>
        Support for cloud platforms, hybrid infrastructure and modern
        enterprise deployment environments.
      </p>
    </div>

    <div className="why-card">
      <FaHandshake className="why-icon" />
      <h3>Long-Term Partnership</h3>
      <p>
        We function as an extension of your internal IT team, helping
        your business grow with confidence.
      </p>
    </div>

  </div>

</section>
{/* ================= TECHNOLOGY STACK ================= */}

<section className="technology-stack">

  <div className="section-heading">

    <span>TECHNOLOGIES WE SUPPORT</span>

    <h2>Enterprise Technologies We Work With</h2>

    <p>
      Our Managed IT Services cover modern application platforms,
      databases, cloud infrastructure, operating systems and
      enterprise technologies.
    </p>

  </div>

  <div className="tech-grid">

    <div className="tech-card">
      <FaReact className="tech-icon" />
      <span>React</span>
    </div>

    <div className="tech-card">
      <FaNodeJs className="tech-icon" />
      <span>Node.js</span>
    </div>

    <div className="tech-card">
      <FaJava className="tech-icon" />
      <span>Java</span>
    </div>

    <div className="tech-card">
      <SiMongodb className="tech-icon" />
      <span>MongoDB</span>
    </div>

    <div className="tech-card">
      <SiMysql className="tech-icon" />
      <span>MySQL</span>
    </div>

    <div className="tech-card">
      <SiPostgresql className="tech-icon" />
      <span>PostgreSQL</span>
    </div>

    <div className="tech-card">
      <FaDatabase className="tech-icon" />
      <span>SQL Server</span>
    </div>

    <div className="tech-card">
      <FaAws className="tech-icon" />
      <span>AWS</span>
    </div>

  <div className="tech-card">
  <FaCloud className="tech-icon" />
  <span>Microsoft Azure</span>
</div>

    <div className="tech-card">
      <SiDocker className="tech-icon" />
      <span>Docker</span>
    </div>

    <div className="tech-card">
      <FaLinux className="tech-icon" />
      <span>Linux</span>
    </div>

    <div className="tech-card">
      <FaWindows className="tech-icon" />
      <span>Windows Server</span>
    </div>

  </div>

</section>
{/* ================= CALL TO ACTION ================= */}

<section className="managed-cta">

  <div className="managed-cta-content">

    <span>READY TO OPTIMIZE YOUR IT OPERATIONS?</span>

    <h2>
      Let E-Forum Systems Manage Your Technology,
      While You Focus on Growing Your Business.
    </h2>

    <p>
      From production support and infrastructure management to disaster
      recovery and application maintenance, we provide reliable,
      scalable, and cost-effective Managed IT Services tailored to
      your organization's needs.
    </p>

    <div className="managed-cta-buttons">

      <button
        className="cta-primary"
        onClick={handleContact}
      >
        Request Consultation
      </button>

      <Link
        to="managed-services"
        smooth={true}
        duration={700}
        offset={-80}
      >
        <button className="cta-secondary">
          Explore Services
        </button>
      </Link>

    </div>

  </div>

</section>
{/* ================= FAQ ================= */}

<section className="managed-faq">

  <div className="section-heading">

    <span>FAQ</span>

    <h2>Frequently Asked Questions</h2>

    <p>
      Find answers to the most common questions about our Managed IT Services.
    </p>

  </div>

  <div className="faq-container">

    {faqs.map((faq, index) => (

      <div className="faq-item" key={index}>

        <button
          className="faq-question"
          onClick={() =>
            setOpenFAQ(openFAQ === index ? null : index)
          }
        >

          <span>{faq.question}</span>

          {openFAQ === index
            ? <FaChevronUp />
            : <FaChevronDown />
          }

        </button>

        <div
          className={`faq-answer ${
            openFAQ === index ? "active" : ""
          }`}
        >
          <p>{faq.answer}</p>
        </div>

      </div>

    ))}

  </div>

</section>

<Footer />



{/* ================= SERVICE PROCESS ================= */}
{/* ================= SERVICE PROCESS ================= */}

<section className="service-process">

  <div className="section-heading">

    <span>OUR PROCESS</span>

    <h2>How We Deliver Managed IT Services</h2>

    <p>
      A streamlined workflow that keeps your IT infrastructure secure,
      monitored and continuously optimized.
    </p>

  </div>

  <div className="process-timeline">

    <div className="process-step">
      <div className="process-number">1</div>
      <h3>Assessment</h3>
      <p>Understand your infrastructure.</p>
    </div>

    <div className="process-arrow">→</div>

    <div className="process-step">
      <div className="process-number">2</div>
      <h3>Planning</h3>
      <p>Create the right support strategy.</p>
    </div>

    <div className="process-arrow">→</div>

    <div className="process-step">
      <div className="process-number">3</div>
      <h3>Deployment</h3>
      <p>Implement monitoring & support.</p>
    </div>

    <div className="process-arrow">→</div>

    <div className="process-step">
      <div className="process-number">4</div>
      <h3>24×7 Support</h3>
      <p>Continuous monitoring & issue resolution.</p>
    </div>

    <div className="process-arrow">→</div>

    <div className="process-step">
      <div className="process-number">5</div>
      <h3>Optimization</h3>
      <p>Improve performance continuously.</p>
    </div>

  </div>

</section>

    </>
  );
}
